import { render, staticRenderFns } from "./UnSubscribe.vue?vue&type=template&id=e776988c&scoped=true"
import script from "./UnSubscribe.vue?vue&type=script&lang=js"
export * from "./UnSubscribe.vue?vue&type=script&lang=js"
import style0 from "./UnSubscribe.vue?vue&type=style&index=0&id=e776988c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e776988c",
  null
  
)

export default component.exports